import { ComponentRef, Directive, Type, ViewContainerRef, Input, Output, EventEmitter } from '@angular/core';
import { BaseSidebarActivityComponent } from './base-sidebar-activity/base-sidebar-activity.component';
import { SidebarActivityType } from './sidebar';
import { MeSidebarActivityComponent } from './me-sidebar-activity/me-sidebar-activity.component';
import { VizSidebarActivityComponent } from './viz-sidebar-activity/viz-sidebar-activity.component';
import { PAActivity } from '../../services/permitted-activity/pa-menu-meta';

@Directive({
  selector: '[appSidebarActivity]',
  standalone: false
})
export class SidebarActivityDirective {
  @Input() activity!: PAActivity;
  @Output() callback: EventEmitter<any> = new EventEmitter();
  
  comp!: ComponentRef<BaseSidebarActivityComponent>;
  
  static readonly components: { [type: string]: Type<BaseSidebarActivityComponent> } = {}

  constructor(public viewContainerRef: ViewContainerRef) {
    SidebarActivityDirective.components[SidebarActivityType.DEFAULT] = MeSidebarActivityComponent;
    SidebarActivityDirective.components[SidebarActivityType.VIZ] = VizSidebarActivityComponent;
  }

  ngOnInit() {
    const builder = new SidebarActivityDirectiveBuilder();
    this.comp = builder.createComps(this.viewContainerRef, SidebarActivityDirective.components[this.activity.type!]);
    this.comp.instance.configure(this.activity);
  }
}

export class SidebarActivityDirectiveBuilder {

  constructor() {}

  createComps<Component>(viewContainerRef: ViewContainerRef, comp: Type<Component>): ComponentRef<Component> {
    viewContainerRef.clear();
    return viewContainerRef.createComponent(comp);
  }
}